const initialState = {
  data:{},
  search:'',
  filter:[],
  sort:{
    field:'user_desc',
    asc:1
  }
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_USERS':
      return {
        ...state,
        data:  action.payload
      }
    case 'SORT_USERS':
      return {
        ...state,
        sort: action.sort
      }
    case 'SEARCH_USERS':
      return {
        ...state,
        search: action.search
      }
    case 'EDIT_USER':
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.user_id]:action.payload
        }
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/users.js